import { Col, Container, Row } from "react-bootstrap";
import exam_image from '../image/New Stud Dash/exam.webp';
import assesment_image from '../image/New Stud Dash/assesment.webp';
import college_image from '../image/New Stud Dash/collegeee.webp';
import career_image from '../image/New Stud Dash/career image.webp';
import scholarships_image from '../image/New Stud Dash/scrolarship_image.webp';
import videos_image from '../image/New Stud Dash/videoss.webp';
import abroad_study from '../image/New Stud Dash/abroad_study.webp';
import mentorships_image from '../image/New Stud Dash/mentorships.webp';
import dashboard_image from '../image/New Stud Dash/dashboard.webp';
import ReadMoreText from "./ReadMore";
function Features() {
    const dash_text = "તમારા માટે એક સરળ અને આસાન ડૅશબોર્ડ, જ્યાં તમે તમારું સંપૂર્ણ કરિયર પ્લાનિંગ, કૉલેજ અને સ્કોલરશિપની માહિતી સરળતાથી જોઈ શકો. દરેક જરૂરી માહિતી એક જ જગ્યાએ મળી રહેશે જેથી તમારે કોઈ શોધખોળ કરવી ન પડે. કરિયરની શ્રેષ્ઠ ગાઇડલાઇન્સ અને ટૂલ્સ તમારું ભવિષ્ય ઘડવામાં સહાયક સાબિત થશે."
    const career_text = "તમારા માટે 250 થી પણ વધુ કરિયરની માહિતી, જેમાંથી તમે તમારું ઇન્ટરેસ્ટ અને કૌશલ્ય પ્રમાણે શ્રેષ્ઠ વિકલ્પ પસંદ કરી શકો. ડૉક્ટર, એન્જિનિયર, ચાર્ટર્ડ એકાઉન્ટન્ટ કે આર્ટ્સ, દરેક ક્ષેત્રની વિગતો તમને મળશે."
    const scholarships_text = "સરકાર અને ખાનગી સંસ્થાઓ દ્વારા આપવામાં આવતી શિષ્યવૃત્તિઓની માહિતી જેનાથી તમે મહાન ભવિષ્ય માટે ફી અને ખર્ચની ચિંતા કર્યા વિના આગળ વધી શકો."
    const college_text = 'ગુજરાતથી લઈને દેશભરની 22,000+ કૉલેજની માહિતી – એડમિશન, ફી, કોર્સ, અને પ્લેસમેન્ટ ડિટેઇલ્સ બધું એક જ જગ્યાએ.'
    const exam_text = "અભ્યાસ અને એડમિશન માટે જરૂરી 150+ પરીક્ષાઓ જેમ કે NEET, JEE, UPSC, GPSC, CLAT અને અન્ય તમામ સ્પર્ધાત્મક પરીક્ષાઓ માટે પૂરી માહિતી મળશે."
    const assesment_text = "તમારા મગજ, રસ અને આવડત પ્રમાણે શ્રેષ્ઠ કરિયર પસંદ કરવા માટે વિજ્ઞાન આધારિત ટેસ્ટ, જે તમારું કરિયર નક્કી કરવામાં મદદ કરશે."
    const videos_text = "રિયલ-લાઇફ એક્સપર્ટ્સના અનુભવથી તમને પ્રેક્ટિકલ જાણકારી મળશે. ઇન્ડસ્ટ્રી એક્સપર્ટસ અને મેન્ટર્સના વિડિયોઝ તમને નવી દિશા બતાવશે."
    const abroad_text = "યુરોપ, અમેરિકા કે કેનેડામાં અભ્યાસ કરવા માંગો છો? તમે કઈ કૉલેજ પસંદ કરવી, ફી કેવી રીતે વ્યવસ્થિત કરવી, વિઝા અને એડમિશન પ્રોસેસ – બધું સમજાવાશે."
    const mentorship_text = "તમારા માટે અનુભવી મેન્ટર્સ, જે તમારા અભ્યાસ, કરિયર અને આગળની દિશા માટે માર્ગદર્શન આપશે. તમને સાચી માહિતી અને દિશા મળશે."
    return (
        <>
            {/* card Features */}
            <Container fluid className="py-5 mt-4">
                <Row className="justify-content-center">
                    <Col lg="11" md="11" xl="9">
                        <Row>
                            <Col xs="12 text-center">
                                <div className="heading_home pb-sm-0 pb-2 fw-bold">Personalized Platform Features</div>
                                <p style={{ fontSize: '20px' }} className="text-muted  desc_header pt-2 pb-4">
                                    કરિયરસહી ટેક્નોલોજી બેઇઝડ કરિયર ગાઈડન્સ પ્લેટફોર્મ છે જ્યાં ઘણા બધા ફીચર્સ આપેલા છે. વિદ્યાર્થીઓ પોતાના કરિયરનો નિર્ણય ખુદ લઇ શકે એ માટે એક સચોટ પ્રોસેસ તૈયાર કરેલ છે </p>
                            </Col>
                            <Col md="12">
                                <div className="bg-white rounded-3 p-3 shadow">
                                    <img className="col-12 w-100 image_border" src={dashboard_image} alt="feature" />
                                    <Row className="pt-3">
                                        <Col md="6" className="d-flex justify-content-center align-items-center">
                                            <h5 className="fw-bold text-center">✅ સરળ સ્ટુડન્ટ ડેશબોર્ડ</h5>
                                        </Col>
                                        <Col md="6">
                                            <ReadMoreText text={dash_text} />
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                        <Row className="pt-4 g-4">
                            <Col sm="6" md="6">
                                <div className="bg-white rounded-3 p-3 h-100 shadow">
                                    <div><img className="col-12 w-100 image_border" src={career_image} alt="feature" /></div>
                                    <h5 className="fw-bold pt-3">🎯 250+ કરિયર્સ વિકલ્પો</h5>
                                    <ReadMoreText text={career_text} />
                                </div>
                            </Col>
                            <Col sm="6" md="6">
                                <div className="bg-white p-3 rounded-3  h-100 shadow">
                                    <div><img className="col-12 w-100 image_border" src={scholarships_image} alt="feature" /></div>
                                    <h5 className="fw-bold pt-3">🎓 600+ સ્કોલરશિપ</h5>
                                    <ReadMoreText text={scholarships_text} />
                                </div>
                            </Col>
                        </Row>
                        <Row className="pt-4  g-4">
                            <Col sm="6" lg="4" className="mt-4">
                                <div className="bg-white rounded-3 p-3  h-100 shadow">
                                    <div><img className="col-12 w-100 image_border" src={college_image} alt="feature" /></div>
                                    <h5 className="fw-bold pt-3">🏛 22,000+ કૉલેજોની માહિતી</h5>
                                    <ReadMoreText text={college_text} />
                                </div>
                            </Col>
                            <Col sm="6" lg="4" className="mt-4">
                                <div className="bg-white rounded-3 p-3  h-100 shadow">
                                    <div><img className="col-12 w-100 image_border" src={exam_image} alt="feature" /></div>
                                    <h5 className="fw-bold pt-3">📖 150+ પરીક્ષાઓની માહિતી</h5>
                                    <ReadMoreText text={exam_text} />
                                </div>
                            </Col>
                            <Col sm="6" lg="4" className="mt-4">
                                <div className="bg-white p-3 rounded-3 h-100 shadow">
                                    <div><img className="col-12 w-100 image_border" src={assesment_image} alt="feature" /></div>
                                    <h5 className="fw-bold pt-3">🧠 સાયકોમેટ્રિક ટેસ્ટ</h5>
                                    <ReadMoreText text={assesment_text} />
                                </div>
                            </Col>
                            <Col sm="6" lg="4" className="mt-4">
                                <div className="bg-white p-3 rounded-3 h-100 shadow">
                                    <div><img className="col-12 w-100 image_border" src={videos_image} alt="feature" /></div>
                                    <h5 className="fw-bold pt-3">🎥 વીડિયો લાઇબ્રેરી</h5>
                                    <ReadMoreText text={videos_text} />
                                </div>
                            </Col>

                            <Col sm="6" lg="4" className="mt-4">
                                <div className="bg-white p-3 rounded-3  h-100 shadow">
                                    <div><img className="col-12 w-100 image_border" src={abroad_study} alt="feature" /></div>
                                    <h5 className="fw-bold pt-3">🌍 અબ્રોડ સ્ટડી માર્ગદર્શન</h5>
                                    <ReadMoreText text={abroad_text} />
                                </div>
                            </Col>
                            <Col sm="6" lg="4" className="mt-4">
                                <div className="bg-white p-3 rounded-3 h-100 shadow">
                                    <div><img className="col-12 w-100 image_border" src={mentorships_image} alt="feature" /></div>
                                    <h5 className="fw-bold pt-3">👩‍🏫 કૉલેજ મેન્ટોરશીપ</h5>
                                    <ReadMoreText text={mentorship_text} />
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </>
    )
}
export default Features